import React from 'react';
import { Waypoint } from 'react-waypoint';
const OffsetTracking = ({ onOffsetReached , rowIdx , children  })=>{
    if (!onOffsetReached) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement(Waypoint, {
        fireOnRapidScroll: false,
        bottomOffset: '90%',
        onEnter: ()=>onOffsetReached(rowIdx)
    }, children);
};
OffsetTracking.displayName = 'OffsetTracking';
export default OffsetTracking;
